import '.az{min-height:100dvh;}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.ci{padding:96px 96px;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.an{max-width:1280px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.cj{gap:144px;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import '.ck{min-width:280px;}.ssr-plugin'
import '.bk{max-width:568px;}.ssr-plugin'
import '.bz{gap:24px;}.ssr-plugin'
import '.cl{margin:48px 0px;}.ssr-plugin'
import '.cm{border-radius:40px;}.ssr-plugin'
import '.cn{padding:48px 0px;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.co{gap:48px;}.ssr-plugin'
import '.cc{gap:12px;}.ssr-plugin'
import '.cp{margin:0 48px;}.ssr-plugin'
import '.at{opacity:0.5;}.ssr-plugin'
import '.ce{font-size:16px;}.ssr-plugin'
import '.cq{margin:0 32px;}.ssr-plugin'
import '.cr{padding:0 48px;}.ssr-plugin'
import '.cs{gap:32px;}.ssr-plugin'
import '.ct{text-align:justify;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.cu{margin-bottom:24px;}.ssr-plugin'
import '.cv{flex-direction:row;}.ssr-plugin'
import '.cw{margin-top:1px;}.ssr-plugin'
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import { styled } from 'inlines'
import { colors } from '../../utils/colors.js'
import { Button } from '../../components/Button.js'
import { IconButton } from '../../components/IconButton.js'
import { Icon } from '../../assets/icons/index.js'
import { Logo } from '../../assets/svg/Logo.js'
import { TextInput } from '../../components/TextInput.js'
import { CheckboxInput } from '../../components/CheckboxInput.js'
import { useLocation } from 'wouter'
import {
  Payment,
  PaymentElement,
  usePayment,
} from '@based/payment-plugin/browser'
import { useQuery } from '@based'
import { Turnstile, type TurnstileHandle } from './Turnstile.js'
import { useVotingRegion, VotingRegion } from '../../hooks/useVotingRegion.js'
import { useEmail } from '../../hooks/useEmail.js'
import { isEmailValid } from '../../../../shared/emailValidation.js'
import { ProcessingPaymentPortal } from './ProcessingPaymentPortal.js'
import { TABLET, MOBILE } from '../../utils/breakpoints.js'
import { transparentColor } from '../../utils/transparentcolor.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { useScrollToTop } from '../../hooks/useScrollToTop.js'
import { ErrorUserMessages } from '../../../../shared/errors.js'
import { checkEligibleCardGeo } from '../../../../shared/voting.js'
import { Meter } from '../../components/Meter.js'
import { Layout } from '../../components/Layout.js'
import { EmailErrorNote, ErrorNote } from './Errors.js'
import { type ParticipatingVotingRegionsResponse } from '../../../../functions/audience/participating-voting-regions/index.js'

type CheckoutPageProps = { votes?: Record<string, number> }

export const CheckoutPage = ({ votes }: CheckoutPageProps) => {
  const [, setLocation] = useLocation()
  const [votingRegion, setVotingRegion] = useVotingRegion()

  useScrollToTop()

  if (votes === undefined) console.warn('CheckoutPage: votes missing')
  const totalVotes = Object.values(votes ?? {}).reduce((a, b) => a + b, 0) // SAFE: empty object when votes not yet loaded

  if (!totalVotes) {
    setLocation('/')
  }

  if (votingRegion.price === undefined)
    console.warn('CheckoutPage: votingRegion.price missing')
  const amount = (votingRegion.price ?? 0) * totalVotes // SAFE: zero price when data not yet loaded
  if (votingRegion.currency === undefined)
    console.warn('CheckoutPage: votingRegion.currency missing')
  const currency = votingRegion.currency || 'eur' // SAFE: fallback to EUR when currency not yet loaded
  const dictionary = useDictionary()

  const { data: publishableKeys, loading: loadingPublishableKeys } = useQuery(
    'payment-stripe-pubkey',
  )

  const {
    data: participatingVotingRegions,
    loading: loadingParticipatingVotingRegions,
  } = useQuery('participating-voting-regions')

  return loadingPublishableKeys || loadingParticipatingVotingRegions ? (
    <Layout>
      <Meter
        value={0}
        simulated
        style={{
          width: '100%',
          maxWidth: '160px',
          marginBottom: '24px',
        }}
      />
    </Layout>
  ) : (
    <div className="az b1"
      id="checkout-page-content"
    >
      {!totalVotes ? (
        0
      ) : (
        <Payment
          stripePublishableKey={publishableKeys.stripePublishableKey}
          locale="en"
          amount={amount}
          currency={currency}
          metadata={{
            votes,
            voteGeo: votingRegion.code,
          }}
          appearance={{
            variables: {
              colorPrimary: '#fff',
              colorBackground: 'rgb(1, 10, 65, 0)',
              colorText: 'rgb(255, 255, 255, 0.5)',
              colorDanger: '#df1b41',
              fontFamily: 'Neulis-Regular, Helvetica, system-ui, sans-serif',
              fontWeightNormal: '400',
              fontSizeBase: '16px',
              borderRadius: '40px',
            },
            rules: {
              '.AccordionItem': {
                border: 'none',
              },
              '.Input': {
                borderColor: 'rgba(255,255,255,0.24)',
                backgroundColor: 'rgb(1, 10, 65, 0)', //'#010a41',
                color: 'white',
              },
              '.Input::placeholder': {
                color: 'rgba(255,255,255,0.5)',
              },
              '.Label': {
                marginBottom: '8px',
              },
            },
          }}
          postConfirmationTokenCheck={async ({ setErrorMessage, cardGeo }) => {
            // INFO: this check happens in the frontend before
            // process payment is requested
            if (!cardGeo || typeof votingRegion.name !== 'string') {
              setErrorMessage(
                `${ErrorUserMessages.CantConfirmCardCountry}::0101`,
              )
              return false
            }

            if (!participatingVotingRegions) {
              setErrorMessage(
                `${ErrorUserMessages.CantConfirmCardCountry}::0102`,
              )
              return false
            }

            try {
              checkEligibleCardGeo(
                participatingVotingRegions,
                votingRegion,
                cardGeo,
              )
            } catch (_error) {
              setErrorMessage(
                `${ErrorUserMessages.CardNotEligible}::${cardGeo}::0103`,
              )
              return false
            }
            return true
          }}
        >
          <Content
            votes={votes as any}
            votingRegion={votingRegion}
            setVotingRegion={setVotingRegion}
            currency={currency}
            amount={amount}
            dictionary={dictionary}
            participatingVotingRegions={participatingVotingRegions!}
          />
        </Payment>
      )}
    </div>
  )
}

export const Content = ({
  votes,
  votingRegion,
  setVotingRegion,
  currency,
  amount,
  dictionary,
  participatingVotingRegions,
}: {
  votes: Record<string, number>
  votingRegion: VotingRegion
  setVotingRegion: (code: string) => void
  currency: string
  amount: number
  dictionary: Record<string, string>
  participatingVotingRegions: ParticipatingVotingRegionsResponse
}) => {
  const [location, setLocation] = useLocation()
  const [lang] = useLanguage()

  const votesCastedForString = Object.keys(votes).join('-')

  const {
    complete,
    submitPayment,
    isWaiting,
    isDelayed,
    isProcessing,
    success,
    error,
    setError,
  } = usePayment()
  const turnstileRef = useRef<TurnstileHandle>(null)

  if (success) {
    setLocation(`/thank-you/${votesCastedForString}`)
  }

  if ((!error && isWaiting) || isDelayed || isProcessing) {
    setLocation(location + '?loading=true')
  }
  if (error) {
    setLocation(location.replaceAll('?loading=true', ''))
  }

  const [turnstileToken, setTurnstileToken] = useState<string | null>(null)
  const [email] = useEmail()
  const [agreedTerms, setAgreedTerms] = useState(false)
  const [agreedNews, setAgreedNews] = useState(false)

  // console.log({
  //   complete,
  //   isWaiting,
  //   isDelayed,
  //   isProcessing,
  //   success,
  //   error,
  // })

  useEffect(() => {
    if (error === null) {
      turnstileRef.current?.reset()
      setTurnstileToken(null)
    }
  }, [error])

  const enabled =
    isEmailValid(email) &&
    !email.endsWith('.') &&
    complete &&
    !error &&
    agreedTerms &&
    !!turnstileToken

  // TODO: remove after new sdk
  type RequestPaymentFunctionPayload = {
    captchaToken: string | null
    metadata: {
      voteGeo: string
      votes: { [countryCode: string]: number }
    }
  }
  const requestPaymentFunctionPayload: RequestPaymentFunctionPayload = {
    captchaToken: turnstileToken,
    metadata: {
      votes,
      voteGeo: votingRegion.code, // TODO: rename voteGeo to voteRegion everywhere
    },
  }

  // console.log('-------', { requestPaymentFunctionPayload })

  const handlePayButton = () => {
    // if (!payButtonClickedTimer.current) {
    //   payButtonClickedTimer.current = setTimeout(() => {
    //     payButtonClickedTimer.current = null
    //   }, 500)
    return submitPayment({
      email,
      requestPaymentFunctionPayload,
    })
    // }
  }

  return (
    <styled.div className="ci h"
      style={{
        [TABLET]: {
          padding: '48px 48px',
        },
        [MOBILE]: {
          padding: '16px 16px',
        },
      }}
    >
      <styled.div className="ap e ao an m cj bo"
        style={{
          '& h2': { textAlign: lang.rtl ? 'right' : 'left' },
          '& h3': { textAlign: lang.rtl ? 'right' : 'left' },
          '& label': { textAlign: lang.rtl ? 'right' : 'left' },
          '& #turnstile-container': { textAlign: lang.rtl ? 'right' : 'left' },
          [TABLET]: {
            flexDirection: 'column',
            gap: '16px',
          },
        }}
      >
        <styled.div className="ck bk m h"
          style={{
            '& p': {
              opacity: 0.5,
              fontSize: 16,
              display: 'flex',
              gap: 12,
            },
            '& svg': {
              minWidth: 24,
            },
          }}
        >
          <div className="e bz">
            <IconButton
              icon={<Icon type="backIcon" />}
              onClick={() => setLocation('/cart')}
            />
            <Logo width={106} height={36} onClick={() => setLocation('/')} />
          </div>
          <styled.h2 className="cl"
            style={{
              [TABLET]: {
                marginBottom: '24px',
              },
            }}
          >
            {dictionary.checkout}
          </styled.h2>
          <AboutTransactionsBlock
            style={{ [TABLET]: { display: 'none' } }}
            dictionary={dictionary}
          />
        </styled.div>

        {/* Right Column */}
        <styled.div className="blur bk m cm cn"
          style={{
            backgroundColor: transparentColor(colors.secondary, 0.5),
            border: `1px solid ${colors.border}`,
            '& p': {
              fontSize: 16,
            },
            '& a': {
              textDecoration: 'underline',
            },
            [TABLET]: {
              maxWidth: '100%',
            },
            [MOBILE]: {
              maxWidth: '100%',
              padding: '24px 0px',
              paddingTop: 32,
            },
          }}
        >
          <PaymentForm
            enabled={enabled}
            isWaiting={isWaiting}
            isProcessing={isProcessing}
            isDelayed={isDelayed}
            setTurnstileToken={setTurnstileToken}
            agreedTerms={agreedTerms}
            setAgreedTerms={setAgreedTerms}
            agreedNews={agreedNews}
            setAgreedNews={setAgreedNews}
            handlePayButton={handlePayButton}
            currency={currency}
            amount={amount}
            error={error}
            setError={setError}
            turnstileRef={turnstileRef}
            dictionary={dictionary}
            participatingVotingRegions={participatingVotingRegions}
            votingRegion={votingRegion}
            setVotingRegion={setVotingRegion}
          />
        </styled.div>
      </styled.div>
      {(!error && isWaiting) || isDelayed || isProcessing ? (
        <ProcessingPaymentPortal />
      ) : null}
    </styled.div>
  )
}

const PaymentForm = ({
  enabled,
  isWaiting,
  isProcessing,
  isDelayed,
  setTurnstileToken,
  agreedTerms,
  setAgreedTerms,
  agreedNews,
  setAgreedNews,
  handlePayButton,
  currency,
  amount,
  error,
  setError,
  turnstileRef,
  dictionary,
  participatingVotingRegions,
  votingRegion,
  setVotingRegion,
}: {
  enabled: boolean
  isWaiting: boolean
  isDelayed: boolean
  isProcessing: boolean
  setTurnstileToken: React.Dispatch<React.SetStateAction<string | null>>
  agreedTerms: boolean
  setAgreedTerms: React.Dispatch<React.SetStateAction<boolean>>
  agreedNews: boolean
  setAgreedNews: React.Dispatch<React.SetStateAction<boolean>>
  handlePayButton: () => void
  currency: string
  amount: number
  error: string | null
  setError: Dispatch<SetStateAction<string | null>>
  turnstileRef: React.RefObject<TurnstileHandle | null>
  dictionary: Record<string, string>
  participatingVotingRegions: ParticipatingVotingRegionsResponse
  votingRegion: VotingRegion
  setVotingRegion: (code: string) => void
}) => {
  return (
    <div className="e f co"
    >
      <SelectPaymentMethod dictionary={dictionary} />
      <Contact dictionary={dictionary} error={error} setError={setError} />
      <AboutTransactionsBlock
        dictionary={dictionary}
        style={{
          display: 'none',
          [TABLET]: {
            display: 'block',
            padding: '0px 48px',
            '& svg': {
              opacity: 0.5,
              marginBottom: '-6px',
              marginRight: '6px',
            },
          },
          [MOBILE]: { padding: '0px 23px' },
        }}
      />
      <Terms
        dictionary={dictionary}
        agreedTerms={agreedTerms}
        setAgreedTerms={setAgreedTerms}
        agreedNews={agreedNews}
        setAgreedNews={setAgreedNews}
      />
      <TurnstileWidget
        setTurnstileToken={setTurnstileToken}
        turnstileRef={turnstileRef}
      />
      {error && (
        <ErrorNote
          error={error}
          dictionary={dictionary}
          participatingVotingRegions={participatingVotingRegions}
          votingRegion={votingRegion}
          setVotingRegion={setVotingRegion}
        />
      )}
      <PayButton
        dictionary={dictionary}
        enabled={enabled}
        isWaiting={isWaiting}
        isProcessing={isProcessing}
        isDelayed={isDelayed}
        currency={currency}
        amount={amount}
        handlePayButton={handlePayButton}
      />
    </div>
  )
}

const SelectPaymentMethod = ({
  dictionary,
}: {
  dictionary: Record<string, string>
}) => {
  return (
    <div className="e f cc"
    >
      <styled.h3 className="cp"
        style={{
          [MOBILE]: {
            margin: '0px 24px',
          },
        }}
      >
        {dictionary.selectPaymentMethod}
      </styled.h3>
      <styled.p className="cp at ce"
        style={{
          [MOBILE]: {
            margin: '0px 24px',
          },
        }}
      >
        {dictionary.allTransactionsSecured}
      </styled.p>
      <styled.div className="cq"
        style={{
          [MOBILE]: {
            margin: '0px 8px',
          },
        }}
      >
        <PaymentElement />
      </styled.div>
    </div>
  )
}

const Contact = ({
  dictionary,
  error,
  setError,
}: {
  dictionary: Record<string, string>

  error: string | null
  setError: Dispatch<SetStateAction<string | null>>
}) => {
  const [email, setEmail] = useEmail()

  return (
    <styled.div className="e f cr cs"
      style={{
        [MOBILE]: {
          padding: '0px 24px',
        },
      }}
    >
      <styled.h3>{dictionary.contact}</styled.h3>
      <TextInput
        value={email}
        onChange={(e) => {
          if (error) {
            setError(null)
          }
          setEmail(e.target.value)
        }}
        onBlur={(e) => {
          if (!isEmailValid(email)) {
            setError(() => ErrorUserMessages.InvalidEmail)
          }
        }}
        label={dictionary.emailFieldLabel}
        style={{ width: 'calc(100% - 24px)' }}
        placeholder="yourname@mail.com"
        id="checkout-page-email-input"
      />
      {error && <EmailErrorNote dictionary={dictionary} error={error} />}
    </styled.div>
  )
}

const Terms = ({
  agreedTerms,
  setAgreedTerms,
  agreedNews,
  setAgreedNews,
  dictionary,
}: {
  agreedTerms: boolean
  setAgreedTerms: React.Dispatch<React.SetStateAction<boolean>>
  agreedNews: boolean
  setAgreedNews: React.Dispatch<React.SetStateAction<boolean>>
  dictionary: Record<string, string>
}) => {
  return (
    <styled.div className="e f cr cs"
      style={{
        [MOBILE]: {
          padding: '0 24px',
        },
      }}
    >
      <styled.h3>{dictionary.termsOfService}</styled.h3>
      <CheckboxInput
        id="checkout-page-action-accept-terms"
        value={agreedTerms}
        onChange={(e) => setAgreedTerms(e.target.checked)}
        label={(() => {
          const [before, after] = (dictionary.termsCheckbox ?? '').split(
            '{{TERMS}}',
          )
          return (
            <p>
              {before}
              <a href="/terms-of-service" target="_blank">
                {dictionary.termsOfService}
              </a>
              {after}
            </p>
          )
        })()}
      />
    </styled.div>
  )
}

const TurnstileWidget = ({
  setTurnstileToken,
  turnstileRef,
}: {
  setTurnstileToken: React.Dispatch<React.SetStateAction<string | null>>
  turnstileRef: React.RefObject<TurnstileHandle | null>
}) => {
  return (
    <styled.div className="e f cr ct cs"
      style={{
        [MOBILE]: {
          padding: '0px 16px',
        },
      }}
    >
      <Turnstile ref={turnstileRef} setTurnstileToken={setTurnstileToken} />
    </styled.div>
  )
}

const PayButton = ({
  enabled,
  isWaiting,
  isProcessing,
  isDelayed,
  handlePayButton,
  currency,
  amount,
  dictionary,
}: {
  enabled: boolean
  isWaiting: boolean
  isDelayed: boolean
  isProcessing: boolean
  handlePayButton: () => void
  currency: string
  amount: number
  dictionary: Record<string, string>
}) => {
  return (
    <styled.div className="e f cr cc"
      style={{
        [MOBILE]: {
          padding: '0px 24px',
        },
      }}
    >
      <Button
        disabled={!enabled || isWaiting || isDelayed || isProcessing}
        onClick={handlePayButton}
        id="checkout-page-pay-button"
      >
        {dictionary.payButton}
      </Button>
    </styled.div>
  )
}

const AboutTransactionsBlock = ({ style, dictionary }) => {
  return (
    <styled.div style={style}>
      <h3 className="bn">
        {dictionary.disclaimers}
      </h3>

      <styled.div className="cu e cv cc"
        style={{
          [TABLET]: {
            marginBottom: '16px',
          },}}
      >
        <Icon
          type="infoIcon"
          style={{ opacity: 0.5, minWidth: 24, minHeight: 24 }}
        />
        <p className="cw">
          {dictionary.noRefundNotice}
        </p>
      </styled.div>
      <styled.div className="cu e cv cc"
        style={{
          [TABLET]: {
            marginBottom: '16px',
          },}}
      >
        <Icon
          type="infoIcon"
          style={{ opacity: 0.5, minWidth: 24, minHeight: 24 }}
        />
        <p className="cw">
          {dictionary.extraFeeNotice}
        </p>
      </styled.div>
      <styled.div className="cu e cv cc"
        style={{
          [TABLET]: {
            marginBottom: '16px',
          },}}
      >
        <Icon
          type="infoIcon"
          style={{ opacity: 0.5, minWidth: 24, minHeight: 24 }}
        />
        <p className="cw">
          {dictionary.taxesIncludedNotice}
        </p>
      </styled.div>
    </styled.div>
  )
}
